export enum ASubheaderTag {
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
}

export enum ASubheaderSize {
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
}

export interface ASubheaderProps extends React.HTMLAttributes<HTMLHeadingElement> {
  text: string;
  element?: ASubheaderTag;
  size?: ASubheaderSize;
}
